import { Component, Input, OnInit } from '@angular/core';
import IMissedEntitiesData = ZoningAPI.IMissedEntitiesData;
import * as _ from 'lodash';
import { MissedEntitiesData } from 'src/app/shared/models/missed-entities-data';
import { MissedEntitiesStatus } from 'src/app/shared/enums/missed-entities-status-enum';

@Component({
    standalone: false,
    selector: 'app-missed-entities-details-icon',
    templateUrl: './missed-entities-details-icon.component.html',
    styleUrls: ['./missed-entities-details-icon.component.scss']
})
export class MissedEntitiesDetailsIconComponent implements OnInit {
    @Input()
    missedEntitiesData: IMissedEntitiesData;

    constructor() {}

    ngOnInit(): void {}

    get missedEntitiesStatus(): MissedEntitiesStatus {
        return MissedEntitiesData.getMissedEntitiesStatus(this.missedEntitiesData);
    }

    getStatusClass(): string {
        switch (this.missedEntitiesStatus) {
            case MissedEntitiesStatus.HAS_ISSUES:
                return 'status-red';
            case MissedEntitiesStatus.NO_ISSUES:
                return 'status-green';
            default:
                return 'status-gray';
        }
    }

    getHint(): string {
        switch (this.missedEntitiesStatus) {
            case MissedEntitiesStatus.HAS_ISSUES:
                return 'Property Records contains missed relations';
            case MissedEntitiesStatus.NO_ISSUES:
                return 'No issues';
            default:
                return 'No data';
        }
    }

    getTooltipValue(): string {
        switch (this.missedEntitiesStatus) {
            case MissedEntitiesStatus.HAS_ISSUES:
                return `
                ${
                    this.missedEntitiesData.missedAbuttingPRsCount
                        ? '<p>Missed Abutting PRs: ' + this.missedEntitiesData.missedAbuttingPRsCount + '</p>'
                        : ''
                }
                ${
                    this.missedEntitiesData.missedAbuttingStreetsCount
                        ? '<p>Missed Abutting Streets: ' + this.missedEntitiesData.missedAbuttingStreetsCount + '</p>'
                        : ''
                }
                ${
                    this.missedEntitiesData.missedPRTagsCount
                        ? '<p>Missed PRs Tags: ' + this.missedEntitiesData.missedPRTagsCount + '</p>'
                        : ''
                }
                `;
            case MissedEntitiesStatus.NO_ISSUES:
                return 'No issues';
            default:
                return 'No data';
        }
    }
}
